
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Tempotravellerhire() {



  const cardData =
  {
    keyword: ' Tempo Traveller Hire for Outstation in Pune',
    heading: 'Vaishnavi Travels: Tempo Traveller Hire for Outstation in Pune',
    headingDescription: 'Vaishnavi Travels provides dependable and affordable Tempo Traveller Hire for Outstation in Pune, perfect for family vacations, corporate tours, school trips, and pilgrimages. Our Tempo Travellers are well-maintained with spacious push-back seats, powerful air-conditioning, and ample luggage space, ensuring a smooth and comfortable journey on long routes. With experienced chauffeurs, timely pickups, and flexible booking options, we make outstation group travel stress-free and convenient. Whether it’s a holiday trip, religious yatra, or business tour, Vaishnavi Travels guarantees safe, reliable, and comfortable Tempo Traveller rental services for outstation travel from Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s grand fort palace and one of the city’s most iconic landmarks. Once the political seat of the Maratha Empire, its mighty gates, gardens, and ancient ruins narrate stories of power and valor. Though destroyed partially by fire in 1828, the fort still attracts thousands daily. The evening light-and-sound show revives tales of Bajirao and Mastani with grandeur. Its courtyards, fountains, and corridors are filled with historic charm. Shaniwar Wada is Pune’s timeless cultural crown jewel."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a monument of national importance tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, the palace serves as a museum housing Gandhi’s personal belongings, photos, and letters. Its sprawling gardens and Italian arches add serene charm. Students, historians, and tourists visit to pay homage to the Father of the Nation. Aga Khan Palace is Pune’s inspirational symbol of sacrifice and heritage."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Perched on a hill, it offers panoramic views of the Sahyadris and thrilling trekking routes. Visitors explore its bastions, memorials, and temples that echo Maratha bravery. During monsoon, misty weather and waterfalls make the experience enchanting. Local stalls serve rustic pithla-bhakri to trekkers and pilgrims. Sinhagad Fort is Pune’s blend of history, adventure, and scenic charm."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established more than 125 years ago, it houses a grand idol adorned with gold and ornaments. During Ganesh Chaturthi, it becomes the epicenter of massive celebrations attracting lakhs of devotees. Known for its charitable and cultural contributions, it is a hub of devotion and service. The temple’s aura is spiritually uplifting for all visitors. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, sanctum chambers, and a Nandi mandapa, it reflects India’s ancient craftsmanship. Despite being in the city center, it provides peace and a meditative atmosphere. Evening chants create an aura of devotion. History lovers admire its simplicity and timeless design. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing more than 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include musical instruments, ornaments, sculptures, and everyday antiques from across India. A highlight is the recreated Mastani Mahal, symbolizing Maratha romance and heritage. Students and tourists find it highly educational and fascinating. It preserves centuries of Indian artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of art and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum enrich the visit. Pilgrims climb 103 steps to reach the temple, blending devotion with scenic beauty. Sunrise and sunset views here are captivating. Parvati Hill is Pune’s sacred and serene retreat above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global center of wellness and spirituality. Spread across lush gardens, it attracts seekers and tourists from around the world. Meditation sessions, yoga practices, and workshops on personal growth are held daily. Its Zen gardens and tranquil meditation halls create a peaceful experience. Beyond spirituality, it offers rejuvenation and relaxation for modern lifestyles. Osho Ashram is Pune’s international hub of mindfulness and healing."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, photography, and peaceful walks here. The garden also symbolizes Indo-Japanese cultural friendship. Its year-round greenery makes it a favorite among nature lovers. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular outskirt retreat near Pune. It supplies water to the city while offering scenic backdrops of hills and flowing waters. Monsoon transforms the dam into a spectacular sight with overflowing water. Families enjoy roadside snacks like roasted corn and tea while relaxing by the banks. It also serves as the starting point for Sinhagad Fort trips. Khadakwasla Dam is Pune’s refreshing natural escape."
  }
],


     "services": [
    {
      "name": "Outstation Tempo Traveller Pune",
      "description": "Explore destinations beyond Pune comfortably with our Outstation Tempo Traveller service. Designed to cater to groups traveling to hill stations, pilgrimage sites, or leisure spots, these vehicles provide spacious interiors, ample luggage capacity, and smooth ride quality. Equipped with professional drivers experienced in long-distance routes, the service ensures punctuality, safety, and convenience for your outstation journey."
    },
    {
      "name": "13 17 Seater Outstation Rental",
      "description": "Choose between 13 and 17 seater Tempo Travellers for your outstation trips from Pune. Perfectly suited for small to medium-sized groups, these vehicles offer ergonomic seating, powerful air conditioning, and sufficient storage space. Ideal for family vacations, corporate retreats, or school excursions, these tempos guarantee comfort and reliability across long distances."
    },
    {
      "name": "AC Tempo Traveller Outstation Pune",
      "description": "Travel cool and relaxed with our air-conditioned Tempo Travellers for outstation trips from Pune. Featuring advanced cooling systems, plush seating, and noise insulation, these vehicles make even long journeys enjoyable. Suitable for corporate travel, family tours, and group outings, our AC tempos ensure passengers remain refreshed regardless of the external climate."
    },
    {
      "name": "Non AC Tempo Outstation Hire",
      "description": "For budget-friendly yet comfortable travel, our non-AC Tempo Traveller outstation hire is an excellent choice. While lacking air conditioning, these vehicles maintain spacious seating and reliable performance, making them ideal for groups seeking economical options without compromising on space or safety during their trips."
    },
    {
      "name": "Family Outstation Tempo Traveller",
      "description": "Plan memorable family trips beyond Pune with our family-friendly Tempo Traveller rentals. These vehicles feature child safety locks, ample legroom, and entertainment options to keep all ages engaged. With courteous drivers and flexible schedules, your family’s comfort and safety are our priority on every outstation journey."
    },
    {
      "name": "Corporate Outstation Tempo Hire",
      "description": "Facilitate efficient and professional outstation travel for your corporate team with our Tempo Traveller rentals. These vehicles come equipped with Wi-Fi, charging ports, and spacious interiors to allow work or relaxation during transit. Our drivers prioritize punctuality and discretion, supporting seamless business travel to any outstation destination."
    },
    {
      "name": "Weekend Outstation Tempo Booking",
      "description": "Make your weekend getaways from Pune hassle-free by booking our outstation Tempo Travellers. Whether it’s a quick trip to nearby hill stations or coastal escapes, these tempos offer reliable and comfortable transport. Enjoy flexible booking options with driver services, fuel management, and toll fee handling to enhance your travel experience."
    },
    {
      "name": "School Trip Tempo Outstation",
      "description": "Ensure safety and convenience for your school’s outstation educational trips with our Tempo Traveller hire service. Equipped with seatbelts, first aid kits, and well-vetted drivers, our tempos provide a secure environment for students and teachers. Real-time tracking and punctual service keep school trips organized and stress-free."
    },
    {
      "name": "Book Tempo Traveller Online Pune",
      "description": "Reserve your outstation Tempo Traveller quickly and easily with our online booking platform. Choose your vehicle type, travel dates, and additional services such as driver preferences or amenities. Receive instant confirmation, transparent pricing, and 24/7 support to make your planning seamless and convenient."
    },
    {
      "name": "Long Distance Tempo Rental",
      "description": "Embark on long-distance journeys with confidence using our Tempo Traveller rentals designed for endurance and comfort. Perfect for interstate travel, pilgrimage tours, and extended family vacations, these vehicles provide ample legroom, robust suspension, and advanced safety features. Our experienced drivers handle routes efficiently, ensuring timely and smooth arrivals."
    },
    {
      "name": "Tempo with Driver Outstation",
      "description": "Opt for a fully managed travel experience with our Tempo Traveller hire that includes professional drivers for outstation trips. Drivers are trained for safety, route knowledge, and customer service, allowing you to focus on enjoying your journey. The package includes fuel management and trip coordination, offering a hassle-free solution for all your travel needs."
    },
    {
      "name": "Budget Outstation Tempo Hire",
      "description": "Avail economical Tempo Traveller rental options for your outstation travels without compromising on essential comfort and safety. Our budget packages cater to groups seeking cost-effective transportation solutions for pilgrimages, school trips, or casual outings, offering transparent pricing and reliable service."
    },
    {
      "name": "Online Outstation Tempo Traveller Pune",
      "description": "Book your outstation Tempo Traveller in Pune online with complete convenience. Our platform offers detailed vehicle descriptions, availability calendars, and easy payment options. Enjoy seamless booking experiences with instant confirmations, transparent rates, and dedicated customer support to address all your travel queries."
    }
  ],
  "tableData": [
    ["Outstation Tempo Traveller Pune", "13 17 Seater Outstation Rental"],
    ["AC Tempo Traveller Outstation Pune", "Non AC Tempo Outstation Hire"],
    ["Family Outstation Tempo Traveller", "Corporate Outstation Tempo Hire"],
    ["Weekend Outstation Tempo Booking", "School Trip Tempo Outstation"],
    ["Book Tempo Traveller Online Pune", "Long Distance Tempo Rental"],
    ["Tempo with Driver Outstation", "Budget Outstation Tempo Hire"],
    ["Online Outstation Tempo Traveller Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Tempo Traveller Hire for Outstation in Pune",
    "WhyChoosedescription": "Vaishnavi Travels provides reliable and comfortable Tempo Traveller hire services in Pune for outstation trips, ideal for families, corporate teams, and groups."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Long Journeys",
    "WhyChoosedescription": "Our Tempo Travellers offer ample seating, headroom, and luggage space, making them perfect for multi-hour or multi-day trips out of Pune."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Well-Maintained Fleet",
    "WhyChoosedescription": "All our vehicles undergo regular servicing and thorough cleaning to ensure hygiene, safety, and top-notch performance."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Outstation Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with popular and offbeat outstation routes from Pune, ensuring a safe and smooth ride."
  },
  {
    "WhyChooseheading": "Custom Rental Plans for Every Group",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day Tempo Traveller rentals — tailored to your group size, destination, and schedule."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Our outstation rental pricing includes fuel, tolls, driver allowance, and taxes — no surprise charges at the end."
  },
  {
    "WhyChooseheading": "Perfect for Family Trips, Pilgrimages & Weekend Getaways",
    "WhyChoosedescription": "Whether you're heading to a temple tour, beach vacation, or a hill station, our Tempo Travellers are a reliable choice."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance & Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to help with bookings, modifications, and travel coordination."
  }
]



















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer Tempo Traveller hire for outstation trips from Pune?',
      answer: 'Yes, Vaishnavi Travels offers well-maintained Tempo Travellers for outstation travel from Pune, suitable for family vacations, group tours, corporate travel, and religious trips.',
    },
    {
      question: 'What features are available in the Tempo Traveller for outstation travel from Pune?',
      answer: 'Our Tempo Travellers come equipped with push-back seats, air-conditioning, ample legroom, spacious interiors, luggage space, and entertainment systems to ensure a comfortable long-distance journey.',
    },
    {
      question: 'Are the Tempo Travellers and drivers reliable for outstation travel from Pune?',
      answer: 'Absolutely! Our vehicles are regularly serviced and maintained, and all Tempo Travellers are driven by experienced, courteous drivers who are familiar with major outstation routes from Pune.',
    },
    {
      question: 'What is the rental cost for Tempo Traveller hire for outstation from Pune?',
      answer: 'Outstation Tempo Traveller rental rates usually start from ₹6,000 per day, depending on distance, travel duration, and vehicle variant (AC/Non-AC, seating capacity, etc.).',
    },
    {
      question: 'Can I hire a Tempo Traveller for multi-day outstation trips from Pune?',
      answer: 'Yes, Vaishnavi Travels offers flexible multi-day packages for outstation travel with transparent pricing and custom itineraries.',
    },
    {
      question: 'How early should I book a Tempo Traveller for outstation travel from Pune?',
      answer: 'It is recommended to book 3-5 days in advance, especially for weekends, public holidays, and vacation seasons, to ensure availability.',
    },
    {
      question: 'Is flexible pickup and drop available for outstation Tempo Traveller rentals from Pune?',
      answer: 'Yes, we provide flexible pickup and drop-off options across Pune and nearby areas as per your convenience.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Nitin Sharma",
    position: "Family Group Leader",
    feedback:
      "We booked a Tempo Traveller from Vaishnavi Travels for an outstation family trip. The vehicle was clean and comfortable, and the driver was very professional. Great experience!",
    rating: 5,
  },
  {
    name: "Ms. Swati Dixit",
    position: "Group Traveler",
    feedback:
      "Vaishnavi Travels made our Pune to outstation trip stress-free. The Tempo Traveller was spacious and well-maintained. Driver knew the route well and drove safely throughout.",
    rating: 5,
    style: "style-2",
  }
];





































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Hire for Outstation in Pune",
  "image": "https://vaishnavitravel.com/assets/images/outstation-tempo-traveller-pune.jpg",
  "description": "Hire outstation Tempo Travellers in Pune with options of AC and Non AC, available in 13 and 17 seater configurations. Ideal for family trips, corporate travel, school trips, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "220"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9000",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/tempo-traveller-outstation-hire-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>Tempo Traveller Hire for Outstation in Pune | AC & Non AC Tempo Rental</title>
  <meta
    name="description"
    content="Hire outstation Tempo Travellers in Pune with options of AC and Non AC, available in 13 and 17 seater configurations. Ideal for family trips, corporate travel, school trips, and weekend getaways."
  />
  <meta
    name="keywords"
    content="Outstation Tempo Traveller Pune, 13 17 Seater Outstation Rental, AC Tempo Traveller Outstation Pune, Non AC Tempo Outstation Hire, Family Outstation Tempo Traveller, Corporate Outstation Tempo Hire, Weekend Outstation Tempo Booking, School Trip Tempo Outstation, Book Tempo Traveller Online Pune, Long Distance Tempo Rental, Tempo with Driver Outstation, Budget Outstation Tempo Hire, Online Outstation Tempo Traveller Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerhire;